const state = {
    list: [],
    error: false,
    done: false,
    loading: false,
    page_loading: false,
    last_page: false,
    is_end: false,
    current_page: null,
}

const getters = {
    sort_list(state) {
        let list = Object.assign([], state.list)
        list.sort((b, a) => a.created_time - b.created_time)
        return list
    },
    all_unread(state) {
        let list = Object.assign([], state.list)
        let all_unread = 0
        list.forEach(l => {
            if (l.user_unread_number && l.user_unread_number > 0) all_unread += Number(l.user_unread_number)
        })
        return all_unread
    }
}

const mutations = {
    getChatList(state, payload) {
        payload.forEach(l => {
            if (!l.user_unread_number) l.user_unread_number = 0
        })
        state.list = payload
    },
    getChatPagination(state, payload) {
        state.list = state.list.concat(payload)
    },
    addChat(state, payload) {
        if ( !payload.user_unread_number ) payload.user_unread_number = 0
        state.list.unshift(payload)
    },
    updateChatLastMessage(state, {index, message, created_time}) {
        state.list[index].last_message = message
        state.list[index].created_time = created_time
    },
    addChatUnread(state, payload) {
        state.list[payload].user_unread_number ++
    },
    resetChatUnread(state, payload) {
        state.list.forEach(l => {
            if (l.id == payload ) l.user_unread_number = 0
        })
    },
    showChatLoading(state) {
        state.loading = true
    },
    closeChatLoading(state) {
        state.loading = false
    },
    updateChatPageLoading(state, payload) {
        state.page_loading = payload
    },
    updateChatLastPage(state, payload) {
        state.last_page = payload
    },
    updateChatIsEnd(state, payload) {
        state.is_end = payload
    },
}

const actions = {
    initChatList({state, commit}, payload) {
        commit('closeChatLoading')
        commit('getChatList', payload)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/chatList/index.js